<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [ngStyle]="overrideStyle"
>
  <path
    d="M11.1421 12.5812C11.1421 13.0005 10.6571 13.2336 10.3297 12.9717L4.88013 8.61197C4.62993 8.4118 4.62993 8.03126 4.88013 7.8311L10.3297 3.47141C10.6571 3.20951 11.1421 3.44259 11.1421 3.86185V12.5812Z"
    fill="white"
  />
  <path
    d="M3.80962 3.22778C3.31425 3.22778 2.89252 3.5063 2.89252 3.85556V12.5074C2.85905 13.3429 4.80036 13.3429 4.76689 12.5074V3.85556C4.80036 3.5063 4.33846 3.22778 3.80962 3.22778Z"
    fill="white"
  />
</svg>
